// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table[data-v-986d5c1e] {\n  margin: 20px 0;\n  background: #fff;\n  padding: 10px;\n  border-radius: 5px;\n}\n.table[data-v-986d5c1e] .el-table th > .cell {\n    color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
